import {
  i
} from "./chunk.FAJKIEWS.js";

// src/components/jb-article-tool-bar/jb-article-tool-bar.css.ts
var jb_article_tool_bar_css_default = i`:host{--button-width: 100%;align-items:center;display:flex;flex-direction:column;justify-content:space-between;row-gap:var(--spacing-m)}@media(min-width: 960px){:host{flex-direction:row;--button-width: auto}}jb-article-share-bar{justify-content:center}@media(min-width: 960px){jb-article-share-bar{justify-content:start}}jb-button-panel{inline-size:var(--button-width)}@media print{:host{display:none}}`;

export {
  jb_article_tool_bar_css_default
};
